/* =============================================================================
   Safegear custom scripts — Horizon 4.1.3
   -----------------------------------------------------------------------------
   Loaded deferred via snippets/custom.globals.liquid.

   Keep vendor-asset-specific logic OUT of this file: if a behaviour belongs to a
   forked block or section, put it in that fork instead. This file is for
   genuinely page-wide behaviour only.
   ============================================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
     Product FAQ — "Ask a question" modal
     Markup lives in snippets/product-faq.liquid, styles in custom.css section 7.

     Listeners are delegated from document rather than bound to the modal, so
     load order and any later re-render of the section cannot break the buttons.
     Every handler no-ops when the modal is absent, which is every page except a
     product page with matching FAQ entries.
     ------------------------------------------------------------------------ */

  var PF_MODAL_ID = 'pf-ask-modal';

  function pfModal() {
    return document.getElementById(PF_MODAL_ID);
  }

  function pfOpen() {
    var modal = pfModal();
    if (!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var firstField = modal.querySelector('input:not([type="hidden"]), textarea');
    if (firstField) firstField.focus();
  }

  function pfClose() {
    var modal = pfModal();
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* The overflow FAQs, revealed in one go. The button removes itself, so this
     is deliberately one-way: there is no "Show less". */
  function pfShowMore(button) {
    var faq = button.closest('.product-faq');
    if (!faq) return;

    var hidden = faq.querySelectorAll('.product-faq__item[hidden]');
    for (var i = 0; i < hidden.length; i++) hidden[i].removeAttribute('hidden');

    var wrap = button.closest('.product-faq__more-wrap') || button;
    wrap.remove();

    // Focus was on the button, which has just been removed. Move it to the
    // first item revealed rather than letting it fall back to <body>.
    if (hidden.length) {
      var summary = hidden[0].querySelector('summary');
      if (summary) summary.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-pf-open]')) {
      pfOpen();
      return;
    }

    if (target.closest('[data-pf-close]')) {
      pfClose();
      return;
    }

    var more = target.closest('[data-pf-more]');
    if (more) {
      pfShowMore(more);
      return;
    }

    // Clicking the backdrop itself, but not the dialog inside it, closes.
    if (target.id === PF_MODAL_ID) pfClose();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = pfModal();
    if (modal && modal.classList.contains('open')) pfClose();
  });

  // Reopen after a form round-trip so the success or error message is visible.
  function pfRestore() {
    var modal = pfModal();
    if (!modal) return;
    if (
      /[?&]contact_posted=true/.test(window.location.search) ||
      modal.querySelector('.pf-modal__success') ||
      modal.querySelector('.pf-modal__error')
    ) {
      pfOpen();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pfRestore);
  } else {
    pfRestore();
  }

  /* ---------------------------------------------------------------------------
     Breadcrumbs — analytics only
     The 2.1.6 section carried an inline script doing four things; three were
     dead or harmful in 4.1.3 and were dropped during the port (see the header
     comment in sections/breadcrumbs.liquid). This click tracking is the part
     worth keeping. It no-ops when gtag is absent.
     ------------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    if (typeof window.gtag !== 'function') return;

    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('.breadcrumb-link');
    if (!link) return;

    window.gtag('event', 'breadcrumb_click', {
      event_category: 'navigation',
      event_label: link.textContent.trim(),
      value: 1
    });
  });

  /* ---------------------------------------------------------------------------
     Request-a-Quote — carry the product into the enquiry

     blocks/cfp.liquid links Call-for-Price products to the quote page with
     ?product=<title>. Liquid cannot read query parameters, so the value is
     transferred into the form here instead.

     Shopify's {% form 'contact' %} includes ANY contact[...] field in the
     notification email, so no change to the vendor contact-form block is needed
     — the fields are appended to the DOM at runtime.

     Field names are English on purpose: they are labels Safegear reads in the
     notification email, not customer-facing copy, so they need no locale map.
     The product TITLE, by contrast, arrives already localised because cfp.liquid
     emits product.title in the active locale.

     Safety: the value is written with .value and .textContent only, never
     innerHTML, so a crafted ?product= cannot inject markup. Length is capped.
     No-ops on every page that lacks both the parameter and a contact form.
     ------------------------------------------------------------------------ */

  function sgQuoteContext() {
    var params = new URLSearchParams(window.location.search);
    var product = params.get('product');
    if (!product) return;

    product = product.trim().slice(0, 200);
    if (!product) return;

    var form =
      document.querySelector('form.contact-form__form') ||
      document.querySelector('form:has([name="contact[email]"])');
    if (!form) return;

    function addField(name, value) {
      if (!value) return;
      if (form.querySelector('[name="' + name + '"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    addField('contact[Product]', product);

    // Add-ons the customer ticked in sections/addons-product.liquid before
    // clicking Request a Quote. Same treatment as the product title: capped,
    // written with .value only. Added 2026.08.27 — the parameter is put on the
    // link by the [data-cfp-quote-cta] click handler further down this file.
    var addons = params.get('addons');
    if (addons) {
      addons = addons.trim().slice(0, 500);
      addField('contact[Add-ons]', addons);
    }

    // The referrer gives Safegear a clickable link back to the item. Guarded to
    // a product URL on this store so an arbitrary referrer is never forwarded.
    var ref = document.referrer;
    if (ref && ref.indexOf(window.location.origin) === 0 && ref.indexOf('/products/') !== -1) {
      addField('contact[Product URL]', ref.slice(0, 500));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sgQuoteContext);
  } else {
    sgQuoteContext();
  }

  /* ---------------------------------------------------------------------------
     Call-for-Price: carry the ticked add-ons into the quote request
     ---------------------------------------------------------------------------
     On a call-for-price product, sections/addons-product.liquid renders a
     Request a Quote link instead of Add to cart. The add-on selection is live
     DOM state that Liquid cannot see, so the link's href is completed here, at
     click time, from the hidden input assets/product-addons.js maintains.

     Delegated from document so it does not care whether the section hydrated
     first, and read at click time rather than on load so the value is whatever
     is ticked at that moment.

     No selection -> nothing appended, and the link behaves exactly as rendered.
     If this script fails to run at all, the link still carries ?product= from
     Liquid. Losing the add-on list is the acceptable failure; losing the quote
     request is not.
     ------------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var cta = target.closest('[data-cfp-quote-cta]');
    if (!cta || !cta.getAttribute('href')) return;

    var config = document.getElementById('selected_addons_config');
    var value = config && config.value ? config.value.trim().slice(0, 500) : '';
    if (!value) return;

    try {
      var url = new URL(cta.getAttribute('href'), window.location.origin);
      url.searchParams.set('addons', value);
      cta.setAttribute('href', url.pathname + url.search);
    } catch (e) {
      // A malformed href is not worth blocking the click for — let the link go
      // as rendered, carrying the product but not the add-ons.
    }
  });

  /* ---------------------------------------------------------------------------
     Knowledge Base hub — client-side search
     Markup lives in sections/kb-hub.liquid, styles in assets/kb.css.

     WHY CLIENT-SIDE AT ALL. Metaobjects are not in Shopify's native storefront
     search, so there is nothing to query. The section emits a JSON index built
     from the six kb_category entries and this filters it in the browser. That
     index STAYS inline in the section: it is Liquid-generated data, not
     behaviour, and it iterates the categories rather than looping faq_entry
     directly so it stays under the 50-item single-type cap against 72 entries.

     NO innerHTML. The 2026.07.04 original built result rows as an HTML string
     with a hand-rolled escaper. Rows are built with createElement and
     textContent here instead, matching the rule already stated for the quote
     context above: nothing in this file writes markup from data.

     THE NO-RESULT MESSAGE COMES FROM THE SECTION, via data-kb-noresult on the
     results container, so it is a schema setting and can be translated. The
     original hardcoded an English sentence in JavaScript, where the
     localisation backlog cannot see it. If the attribute is absent the panel
     simply hides rather than showing an empty box.

     No-ops on every page without the hub, which is every page but one.
     ------------------------------------------------------------------------ */

  function sgKbSearch() {
    var input = document.getElementById('kb-search-input');
    var out = document.getElementById('kb-search-results');
    if (!input || !out) return;

    var grid = document.getElementById('kb-hub-grid');
    var popular = document.getElementById('kb-hub-popular');
    var popularHeading = document.getElementById('kb-hub-popular-h');
    var indexEl = document.getElementById('kb-search-index');

    var data = [];
    try {
      data = JSON.parse((indexEl && indexEl.textContent) || '[]');
    } catch (error) {
      data = [];
    }
    if (!Array.isArray(data)) data = [];

    // The category grid and the curated list are the browse view. They are
    // hidden while a search is showing results and restored when it is not.
    function setBrowse(show) {
      var value = show ? '' : 'none';
      if (grid) grid.style.display = value;
      if (popular) popular.style.display = value;
      if (popularHeading) popularHeading.style.display = value;
    }

    function buildRow(item) {
      var link = document.createElement('a');
      link.className = 'kb-qrow';
      link.href = item.u || '#';

      var question = document.createElement('span');
      question.className = 'kb-qrow__q';
      question.textContent = item.q || '';
      link.appendChild(question);

      if (item.c) {
        var tag = document.createElement('span');
        tag.className = 'kb-qrow__tag';
        tag.textContent = item.c;
        link.appendChild(tag);
      }

      return link;
    }

    function render(term) {
      term = (term || '').trim().toLowerCase();

      while (out.firstChild) out.removeChild(out.firstChild);

      if (!term) {
        out.hidden = true;
        setBrowse(true);
        return;
      }

      var matches = data
        .filter(function (item) {
          var haystack = [item.q, item.a, item.c, item.t].join(' ');
          return haystack.toLowerCase().indexOf(term) !== -1;
        })
        .slice(0, 12);

      if (!matches.length) {
        var message = out.getAttribute('data-kb-noresult');
        if (message) {
          var none = document.createElement('p');
          none.className = 'kb-hub__noresult';
          none.textContent = message;
          out.hidden = false;
          out.appendChild(none);
        } else {
          out.hidden = true;
        }
        setBrowse(true);
        return;
      }

      out.hidden = false;
      setBrowse(false);
      for (var i = 0; i < matches.length; i++) out.appendChild(buildRow(matches[i]));
    }

    input.addEventListener('input', function () {
      render(input.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sgKbSearch);
  } else {
    sgKbSearch();
  }
})();
